<div
    class="alarm-wrapper"
    data-cy="channels-side-menu-alarm-settings"
    *ngIf="!isSheetLoading && canEditSheet; else loadingSpinner">
    <div *ngIf="selectedChannel" class="alarm-info">
        <p data-cy="channels-side-menu-alarm-settings-channel-name">
            <span>{{ 'channel.alarm.label.name' | translate }}</span> :
            {{ selectedChannel.opsData.name }}
        </p>
        <p data-cy="channels-side-menu-alarm-settings-channel-no">
            <span>{{ 'channel.alarm.label.tag' | translate }}</span> :
            {{ selectedChannel.opsData.tag }}
        </p>
    </div>
    <div *ngIf="!selectedChannel" class="alarm-wrapper-select" data-cy="channels-side-menu-alarm-settings-no-selected">
        {{ 'channel.alarm.select' | translate }}
    </div>
    <div class="alarm-input-wrapper" *ngIf="selectedChannel && !isSystemChannel">
        <div class="sensor-data">
            <app-channel-select-input
                name="opsDataChannelType"
                label="channel.alarm.form.channel-type"
                [value]="newChannel.opsData.channelType"
                (inputChange)="onInputChange($event)"
                [itemList]="CHANNEL_TYPE_STRINGS"></app-channel-select-input>
            <div *ngIf="isRunning || isFlow" class="channel-setting-info">
                <div class="channel-setting-row">
                    <span class="tab">
                        {{ 'channel.setting.label.full-scale-range' | translate }}
                    </span>
                    <span class="tab Text-Style-2">
                        {{ fullScaleRangeDisplay }}
                    </span>
                </div>

                <div *ngIf="!isFlow" class="channel-setting-row">
                    <span class="tab">
                        {{ 'channel.setting.label.unit' | translate }}
                    </span>
                    <span class="tab Text-Style-2">
                        {{ newChannel.opsData.measurementUnit }}
                    </span>
                </div>
            </div>
            <app-channel-text-input
                *ngIf="(isAnalog || isFlow || isRunning || isExhGas) && !isChannelBlank()"
                name="measurementUnit"
                label="channel.alarm.form.unit"
                [value]="isRunning ? 'HR.M' : newChannel.opsData.measurementUnit"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="handleFocusChanged()"
                [isDisabled]="isRunning">
            </app-channel-text-input>
            <div class="status-setting" *ngIf="isDigitalContact">
                <label class="title">
                    {{ 'channel.alarm.form.status.setting' | translate }}
                </label>

                <mat-radio-group class="status-options" [(ngModel)]="statusSetting">
                    <mat-radio-button [value]="StatusSetting.PRESET" disableRipple>{{
                        'channel.alarm.form.status.setting-preset' | translate
                    }}</mat-radio-button>
                    <mat-radio-button [value]="StatusSetting.CUSTOM" disableRipple>{{
                        'channel.alarm.form.status.setting-custom' | translate
                    }}</mat-radio-button>
                </mat-radio-group>
            </div>
            <app-channel-select-input
                *ngIf="isDigitalContact"
                name="status"
                label="Status"
                [value]="newChannel.fcuData.digitalAlarmSetting.statusString"
                (inputChange)="onInputChange($event)"
                [itemList]="CONST_DI_STATUS_TEXT"
                [isDisabled]="statusSetting === StatusSetting.CUSTOM"></app-channel-select-input>
            <div *ngIf="isDigitalMotor" class="motor-type-section">
                <app-channel-select-input
                    name="motorStatus"
                    label="channel.setting.form.motor"
                    [value]="newChannel.fcuData.motorChannelSetting?.motorType"
                    (inputChange)="onInputChange($event)"
                    [itemList]="CONST_DM_STATUS_TEXT"></app-channel-select-input>
            </div>
            <div class="normal-range" *ngIf="isAnalog || isExhGas">
                <h5 class="alarm-form-title" data-cy="channels-side-menu-alarm-settings-measuring-range-section-label">
                    {{ 'channel.alarm.label.measuring-range' | translate }}
                </h5>
                <div class="normal-range-input-wrapper">
                    <app-channel-text-input
                        name="measuringRangeMin"
                        label="channel.alarm.form.min"
                        [value]="measurableRangeMinString"
                        (onInputChange)="onInputChange($event)"
                        (onFocusChange)="handleFocusChanged()">
                    </app-channel-text-input>
                    <div class="normal-range-fixed-text">-</div>
                    <app-channel-text-input
                        name="measuringRangeMax"
                        label="channel.alarm.form.max"
                        [value]="measurableRangeMaxString"
                        (onInputChange)="onInputChange($event)"
                        (onFocusChange)="handleFocusChanged()">
                    </app-channel-text-input>
                </div>
            </div>
            <div class="normal-range" *ngIf="isAnalog && !isChannelBlank()">
                <div class="normal-range-header">
                    <h5 class="alarm-form-title" data-cy="channels-side-menu-alarm-settings-normal-range-section-label">
                        {{ 'channel.alarm.label.normal-range' | translate }}
                    </h5>
                    <mat-slide-toggle
                        class="autosave-toggle"
                        [checked]="isNormalRangeEnabled"
                        (change)="updateNormalRangeEnable($event)"
                        [disabled]="isRunning">
                    </mat-slide-toggle>
                </div>
                <mat-slider
                    class="normal-range-slider"
                    [min]="newChannel.fcuData.measurableRange.min || 0"
                    [max]="newChannel.fcuData.measurableRange.max || 0"
                    [step]="sliderStep"
                    [disabled]="!isNormalRangeEnabled"
                    style="pointer-events: none">
                    <input matSliderStartThumb [value]="newChannel.fcuData.normalRange.min || 0" />
                    <input matSliderEndThumb [value]="newChannel.fcuData.normalRange.max || 0" />
                </mat-slider>
                <div class="normal-range-input-wrapper">
                    <app-channel-text-input
                        name="normalRangeMin"
                        label="channel.alarm.form.min"
                        [value]="normalRangeMinString"
                        (onInputChange)="onInputChange($event)"
                        (onFocusChange)="handleFocusChanged()"
                        [inputValueValidation]="onNormalRangeValidation"
                        [isDisabled]="isRunning">
                    </app-channel-text-input>
                    <div class="normal-range-fixed-text">-</div>
                    <app-channel-text-input
                        name="normalRangeMax"
                        label="channel.alarm.form.max"
                        [value]="normalRangeMaxString"
                        (onInputChange)="onInputChange($event)"
                        (onFocusChange)="handleFocusChanged()"
                        [inputValueValidation]="onNormalRangeValidation"
                        [isDisabled]="isRunning">
                    </app-channel-text-input>
                </div>
            </div>
            <label class="alarm-settings-label" *ngIf="isAnalog || isRunning || isFlow">
                {{ 'channel.alarm.label.alarm-setting' | translate }}</label
            >
            <label class="alarm-settings-label" *ngIf="isDigitalMotor">
                {{ 'channel.alarm.label.motor-setting' | translate }}</label
            >
            <div
                class="alarm-form-header"
                *ngIf="isAnalog || isDigitalMotor || isRunning || isFlow"
                (click)="toggleAlarmForms()">
                <h5 class="alarm-form-title" data-cy="channels-side-menu-alarm-settings-collapse-all-label">
                    {{ (isShowSelect ? 'channel.alarm.label.collapse' : 'channel.alarm.label.expand') | translate }}
                </h5>

                <mat-icon class="arrow" [class.focus]="isShowSelect" svgIcon="dropdown-arrow"></mat-icon>
            </div>
        </div>
        <app-channel-panel-alarm-contact
            *ngIf="isDigitalContact"
            [statusSetting]="statusSetting"
            [isShowSelect]="isShowSelect"
            [isEnabled]="newChannel.fcuData.digitalAlarmSetting?.enable"
            [digitalAlarmSetting]="newChannel.fcuData.digitalAlarmSetting"
            (onSwapStatus)="handleSwapStatus()"
            (onChange)="handleContactChange()"></app-channel-panel-alarm-contact>
        <app-channel-panel-alarm-forms-list
            *ngIf="!isChannelBlank()"
            [style.display]="isShowSelect ? null : 'none'"
            [newChannel]="newChannel"
            [isAnalog]="isAnalog"
            [isRunning]="isRunning"
            [isFlow]="isFlow"
            [isExhGasDev]="isExhGasDev"
            [isExhGasMean]="isExhGasMean"
            [isDigitalMotor]="isDigitalMotor"
            (onChannelChange)="onInputChange($event)"
            (onFocusChange)="handleFocusChanged()"></app-channel-panel-alarm-forms-list>
        <app-channel-alarm-form
            *ngIf="isDigitalContact"
            class="alarm-form-container"
            panelTitle="channel.alarm.label.alarm-setting"
            property="digitalAlarmSetting"
            [selectedChannel]="selectedChannel"
            (onChannelChange)="onInputChange($event)"
            (onFocusChange)="handleFocusChanged()">
        </app-channel-alarm-form>
    </div>
</div>

<ng-template #loadingSpinner>
    <ng-container *ngIf="canEditSheet">
        <app-loading-spinner class="spinner-component"></app-loading-spinner>
    </ng-container>
    <ng-container *ngIf="!canEditSheet">
        <div class="not-allowed-text">
            {{ 'channel.alarm.not-allowed-edit' | translate }}
        </div>
    </ng-container>
</ng-template>
